<template>
    <div id="header">
        <!-- <div id="badge-madeinfrance">
        </div> -->
        <!-- TOP HEADER -->
        <div id="infos" class="d-flex justify-content-start align-items-center ">
            <div class="container position-relative px-0 py-1">
                <a class="adresse text-decoration-none d-none d-lg-inline-block"
                    href="https://goo.gl/maps/ZLqixTuupWXuvSAn9" target="_blank">
                    <img class="img-map mr-2" src="@/../public/elements/lt-icone-map-moutarde.png" />
                    <span class="d-none d-lg-inline-block">7 rue de la République, 76000 Rouen</span>
                </a>
                <a class="horaires text-decoration-none ml-2 d-none d-lg-inline-block" href="#">
                    <img class="img-clock mr-2" src="@/../public/elements/lt-icone-clock-moutarde.png" />
                    <span class="d-none d-lg-inline-block">Lundi au Vendredi 9h - 12h30 > 14h - 18h30</span>
                </a>
                <a class="horaires text-decoration-none d-inline-block d-lg-none" href="contact">
                    <img class="img-map" src="@/../public/elements/lt-icone-email-moutarde.svg" />
                    <span>Contact</span>
                </a>

                <!-- Espace Téléphone for Desktop -->
                <div id="tel" class="position-absolute d-none d-lg-inline-block">
                    <a class="position-absolute text-center text-decoration-none" href="te:0676124578">06 76 12 45 78</a>
                    <img class="back-tel" src="@/../public/elements/lt-background-phone-violet.png" />
                </div>
            </div>
        </div>

        <!-- Espace Téléphone for Mobile -->
        <div id="tel" class="position-absolute d-inline-block d-lg-none">
            <a class="position-absolute text-center text-decoration-none" href="tel:0676124578">06 76 12 45 78</a>
            <img class="back-tel" src="@/../public/elements/lt-background-phone-violet.png" />
        </div>

        <!-- NAVBAR-->
        <div id="navbar" class="bg-1">
            <nav
                class="navbar navbar-expand-lg d-flex justify-content-center aligns-item-center bg-1 container px-0 py-3">
                <div class="w-100 px-3 d-flex justify-content-between  d-lg-none">
                    <a class="navbar-brand nav-brand-mobile d-flex" href="accueil">
                        <img class="icone-logo  d-none d-sm-none d-md-block d-lg-none"
                            src="@/../public/elements/lt-icone-logo-laboratoire-tournier.svg" />
                        <img class="logo" src="@/../public/elements/logo-laboratoire-tournier.png" />
                    </a>
                    <button class="navbar-toggler navbar-toggler-right c-2" type="button" data-toggle="collapse"
                        data-target=".navbar-collapse">
                        ☰
                    </button>
                </div>
                <div class="navbar-collapse collapse">
                    <ul class="nav navbar-nav nav-left">
                        <li class="nav-item" v-for="(menuLeft, index) of $parent.dataIris.menuHeaderLeft.itemsMenu.children" :key="index">
                            <router-link tag="a" :to="menuLeft.route" class="nav-link" href="#">{{menuLeft.labelMenu}}</router-link>
                        </li>
                    </ul>
                </div>
                <a class="navbar-brand nav-brand-desktop mx-auto d-none d-lg-block position-absolute" href="accueil">
                    <img src="@/../public/elements/logo-laboratoire-tournier.png" />
                </a>
                <div class="navbar-collapse collapse">
                    <ul class="nav navbar-nav ml-auto nav-right">
                        <li class="nav-item" v-for="(menuRight, index) of $parent.dataIris.menuHeaderRight.itemsMenu.children" :key="index">
                            <router-link tag="a" :to="menuRight.route" class="nav-link" href="#">{{menuRight.labelMenu}}</router-link>
                        </li>
                        <li class="nav-item d-lg-none">
                            <a class="nav-link c-2" href="https://ezio.fr/connexion" target="new">Espace Professionnels</a>
                        </li>
                    </ul>
                </div>
                <!-- Espace Professionnel -->
                <div class="esp-pro d-none d-lg-flex flex-row justify-content-between align-items-center">
                    <a href="contact"><img class="mail" src="@/../public/elements/lt-icone-mail-violet.png" /></a>
                    <div class="prof d-flex flex-row align-items-center">
                        <a href="https://ezio.fr/connexion" target="new" class="d-flex flex-row align-items-center">
                            <img class="user" src="@/../public/elements/lt-icone-user-gris.png" />
                            <p class="m-0">Espace Professionnel</p>
                        </a>
                    </div>
                </div>
            </nav>
        </div>

        
        <!-- Exemple Import d'un element en SVG Dynamic Color <icone-map height="28px" :color="color1" /> -->
        <v-style>
            /*
                Use CustomerVar with example : {{customizableVar1}}
                Set Background Image with example : background-image:url('\{\{require('@/html/elements/after-page-title-0f555d.svg')}}') !important;
            */      
        </v-style>
    </div>
</template>
<script>
// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

/*  
Exemple Import d'un element en SVG :
import IconeClock from "../html/elements/lt-icone-clock.vue";
*/

export default {
    name: "espHeader",
    components: {
        // Exemple Import d'un element en SVG : ajouter ici : IconeClock,
    },
    props: {
        dataPage:{
            type: Object
        }
    },
    data() {
        return {
          
        }
    },
    computed:{
        color1: function () {
            if(this.dataPage.customizableVar[0].selectItems[0].value){
                return this.dataPage.customizableVar[0].selectItems[0].value
            }else{
                return "0f555d"
            }
        },
        color2: function () {
            if(this.dataPage.customizableVar[0].selectItems[1].value){
                return this.dataPage.customizableVar[0].selectItems[1].value
            }else{
                return "0f555d"
            }
        },
        color3: function () {
            if(this.dataPage.customizableVar[0].selectItems[2].value){
                return this.dataPage.customizableVar[0].selectItems[2].value
            }else{
                return "0f555d"
            }
        },
        customizableVar1: function () {
            if(this.dataPage.customizableVar[0].value.value){
                return this.dataPage.customizableVar[0].value.value
            }else{
                return "0f555d"
            }
        }
    },
    created() {
       
    },
    methods: {
        chartStringBr(val){
            return val.replace(' ', '<br>')
        },
    },  
}
</script>
